import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const TemplatesList = Loadable(
  lazy(() =>
    import("./EmailTemplatesList").then(({ TemplatesList }) => ({
      default: TemplatesList,
    }))
  )
);

const MessagingTemplate = Loadable(
  lazy(() =>
    import("./EmailTemplate").then(({ MessagingTemplate }) => ({
      default: MessagingTemplate,
    }))
  )
);

export const templateRoutes = [
  {
    path: "/email-templates",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.TEMPLATES]}>
        <TemplatesList />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/email-templates/manage-template",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.TEMPLATES]}>
        <MessagingTemplate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/email-templates/manage-template/:templateCode",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.TEMPLATES]}>
        <MessagingTemplate />
      </AuthorizedRoute>
    ),
  },
];
